import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './RangeFilterGenerator.css';

export class RangeFilterGeneratorComponent extends Component {
  constructor(props) {
    const { selectedValue, filterValues } = props;
    super(props);
    this.state = {
      values: selectedValue || filterValues || [],
    };
  }

  handleMin(input) {
    const value = Number.isNaN(input) ? 0 : input;
    const values = [value, this.state.values[1]];
    this.setState({
      values,
    });

    this.props.handleChange(this.props.filterable, values);
  }

  handleMax(input) {
    const value = Number.isNaN(input) ? 0 : input;
    const values = [this.state.values[0], value];
    this.setState({
      values,
    });

    this.props.handleChange(this.props.filterable, values);
  }

  render() {
    const {
      filterValues,
      selectedValue,
    } = this.props;

    const values = selectedValue || filterValues || [];
    return (
      <div>
        <input
          type="number"
          defaultValue={values[0]}
          placeholder="Min"
          style={{ width: '40%' }}
          className="form-control"
          onChange={event => {
            this.handleMin(parseInt(event.target.value, 10));
          }}
        />
        -
        <input
          type="number"
          defaultValue={values[1] ? values[1] : ''}
          placeholder="Enter Max"
          style={{ width: '40%' }}
          className="form-control"
          onChange={event => {
            this.handleMax(parseInt(event.target.value, 10));
          }}
        />
      </div>
    );
  }
}

RangeFilterGeneratorComponent.propTypes = {
  filterable: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  filterValues: PropTypes.arrayOf(PropTypes.number),
  selectedValue: PropTypes.arrayOf(PropTypes.number),
};

export default RangeFilterGeneratorComponent;



// WEBPACK FOOTER //
// ./src/components/Filter/RangeFilterGenerator.js